import { Stack, styled, Typography, useTheme } from "@mui/material";
import PrimaryButton from "components/button/PrimaryButton";
import FlexRowAlign from "components/flexbox/FlexRowAlign";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import Lottie from "react-lottie";
import * as animationData1 from "../../assets/json/chart-1.json";
import * as animationData from "../../assets/json/chart.json";

const Section = styled("section")(({ theme }) => ({}));

export const Section2 = () => {
  const innerHeight = window.innerHeight;
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: false,
    margin: `${-innerHeight / 4}px`,
  });
  const theme = useTheme();
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Section
      ref={ref}
      sx={{
        position: "relative",
        scrollSnapAlign: "center",
      }}
    >
      <Stack
        sx={{ height: "100%", alignItems: "center", justifyContent: "center" }}
      >
        <FlexRowAlign
          gap={{ xs: 0, md: 10, lg: 30 }}
          sx={{ width: "100%", px: { xs: "0px", md: "100px" }, flexWrap: { xs: "wrap", md: 'nowrap' } }}
        >
          <Stack
            sx={{
              width: "50vh",
              aspectRatio: 1,
              borderRadius: "3rem",
              boxShadow: `inset 0px 0px 50px ${theme.palette.background.default},inset 0px 0px 50px ${theme.palette.background.default}`,
              position: "relative",
              overflow: "hidden",
              justifyContent: "flex-end",
              pb: 5,
            }}
          >
            <motion.div
              initial={{
                opacity: 0,
                transform: `scale(2)`,
                overflow: "hidden",
                position: "absolute",
                top: 0,
                filter: "blur(20px)",
              }}
              animate={{
                opacity: isInView ? 1 : 0,
                transform: `scale(${isInView ? 0.9 : 2})`,
                filter: `blur(${isInView ? 0 : 20}px)`,
              }}
              transition={{
                delay: 0.5,
              }}
            >
              <Lottie options={defaultOptions1} height={300} width={"100%"} />
            </motion.div>
            <motion.div
              style={{ transform: "scale(1.2)" }}
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: isInView ? 0.5 : 0,
              }}
              transition={{
                delay: 0.3,
              }}
            >
              {isInView && (
                <Lottie options={defaultOptions} height={300} width={400} />
              )}
            </motion.div>
            <Stack
              sx={{
                background: 'url("static/layouts/background-grid.svg")',
                height: "200%",
                width: "200%",
                position: "absolute",
                top: "-50%",
                left: "-80%",
                zIndex: -1,
                transform: "scale(0.9) rotate(90deg)",
              }}
            />
            <motion.div
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                top: 0,
                left: 0,
              }}
              initial={{
                filter: "blur(200px)",
              }}
              animate={{
                filter: `blur(${isInView ? 15 : 200}px)`,
              }}
              transition={{
                duration: 1,
              }}
            >
              <motion.img
                src="logo.svg"
                style={{
                  width: "60%",
                  height: "60%",
                  position: "absolute",
                  top: "20%",
                  left: "20%",
                  objectFit: "contain",
                  zIndex: -1,
                  opacity: 0.15,
                  filter: "blur(15px)",
                  transform: "scale(1)",
                }}
                animate={{
                  rotate: [0, -360],
                }}
                transition={{
                  duration: 20,
                  ease: "linear",
                  times: [0, 1],
                  repeat: Infinity,
                }}
              />
            </motion.div>
          </Stack>
          <Stack spacing={3} alignItems={{ xs: 'center', md: 'flex-start' }} position={"relative"}>
            <motion.div
              initial={{
                transform: `translateX(50vw) scaleY(0)`,
                opacity: 0,
              }}
              animate={{
                transform: `translateX(${isInView ? 0 : 50}vw) scaleY(${isInView ? 1 : 0
                  })`,
                opacity: isInView ? 1 : 0,
              }}
              transition={{
                type: "spring",
                stiffness: 700,
                damping: 30,
                delay: 0.2,
              }}
            >
              <Typography
                textAlign={{ xs: 'center', md: 'left' }}
                sx={{
                  textTransform: "uppercase",
                  fontWeight: 700,
                  fontSize: { xs: 36, sm: 40, lg: 48 },
                }}
              >
                Trade With Yield
              </Typography>
            </motion.div>
            <motion.div
              initial={{
                transform: `translateX(50vw) scaleY(0)`,
                opacity: 0,
              }}
              animate={{
                transform: `translateX(${isInView ? 0 : 50}vw) scaleY(${isInView ? 1 : 0
                  })`,
                opacity: isInView ? 1 : 0,
              }}
              transition={{
                type: "spring",
                stiffness: 700,
                damping: 40,
                delay: 0.25,
              }}
            >
              <Typography
                textAlign={{ xs: 'center', md: 'left' }}
                sx={{
                  fontWeight: 400,
                  maxWidth: 400,
                  fontSize: { xs: 12, sm: 20, lg: 24 },
                }}
              >
                Flaex is a perpetual DEX with native yield for traders. The
                yield creates new revenue streams and provides rewards for
                users.
              </Typography>
            </motion.div>
            <motion.div
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
              transition={{ duration: 0.2, delay: 0.9 }}
            >
              <FlexRowAlign gap={4} justifyContent={"flex-start"}>
                <Typography color={"text.secondary"}>BACKED BY</Typography>
                <img src="static/logo/AAVE.svg" style={{ height: 20 }} />
              </FlexRowAlign>
            </motion.div>
            <motion.div
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
              transition={{ duration: 0.2, delay: 0.9 }}
            >
              <PrimaryButton
                sx={{
                  background: "linear-gradient(90deg,#AA3AF6,#FDA9E5)",
                  color: "#000",
                  fontWeight: 700,
                }}
              >
                VIEW THE DOC
              </PrimaryButton>
            </motion.div>
          </Stack>
        </FlexRowAlign>
      </Stack>
    </Section>
  );
};

const ChartImage = styled(Stack)(({ theme }) => ({
  clipPath: "url(#chart-svg)",
  background: "#fff",
  height: 482,
  width: 482,
}));
